<mat-list class="document-list">
  @for (fileName of fileNames; track fileName) {
    <mat-list-item>
      <div
        class="document-list-item"
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <div fxFlex="85" fxLayout="column">
          <div>
            <a
              (click)="openCustomDocument(fileName)"
              fxFlex="100"
              class="document-name"
              ><mat-icon class="document-icon">task</mat-icon> {{ fileName }}</a
            >
          </div>
          <div matListItemLine class="document-datecreated">
            {{
              documentAttribute.updatedOn | localDate: 'MMM DD, YYYY h:mm:ss A'
            }}
          </div>
        </div>
        <div fxFlex="15">
          <button
            mat-icon-button
            aria-label="Download file"
            (click)="openCustomDocument(fileName)"
          >
            <mat-icon>file_download </mat-icon>
          </button>
        </div>
      </div>
    </mat-list-item>
  }
</mat-list>
